module.exports = __webpack_public_path__ + "img/water01.e54241a5.jpg";